import { useState, useEffect, useCallback, useRef } from 'react';

const WS_URL = process.env.REACT_APP_WS_URL || 'wss://your-websocket-url';

export const useWebSocket = (onMessage, country) => {
  const [wsConnection, setWsConnection] = useState(null);
  const countryRef = useRef(country);

  // Keep the ref in sync with the latest country value
  useEffect(() => {
    countryRef.current = country;
  }, [country]);

  const connectWebSocket = useCallback(() => {
    if (wsConnection) {
      wsConnection.close();
    }
    
    console.log('Connecting to WebSocket:', WS_URL);
    const ws = new WebSocket(WS_URL);
    
    ws.onopen = () => {
      console.log('WebSocket connected successfully');
      setWsConnection(ws);
    };
    
    ws.onmessage = (event) => {
      console.log('WebSocket message received:', event.data);
      const message = JSON.parse(event.data);
      if (message.type === 'CONTRACT_UPDATE' || message.type === 'OPERATIONAL_UPDATE') {
        // Determine the country of the incoming message (default to 'IT' if absent)
        const messageCountry = message.country || 'IT';
        const currentCountry = countryRef.current;

        // Only process the message if the country matches the currently selected country
        if (messageCountry !== currentCountry) {
          console.log(`WebSocket message filtered out: message country=${messageCountry}, selected country=${currentCountry}`);
          return;
        }

        console.log('Message received via WebSocket:', message.type, message.data);
        onMessage(message);
      }
    };
    
    ws.onclose = (event) => {
      console.log('WebSocket disconnected:', event.code, event.reason);
      console.log('Reconnecting in 3 seconds...');
      setTimeout(connectWebSocket, 3000);
    };
    
    ws.onerror = (error) => {
      console.error('WebSocket error:', error);
    };
  }, [wsConnection, onMessage]);

  useEffect(() => {
    connectWebSocket();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { wsConnection };
};
